import React, { useEffect, useState } from "react";
import { User, Building2, Lock } from "lucide-react";
import axios from "axios";
import "./profile.css";
import { Eye, EyeOff } from "lucide-react";

// ✅ TOASTIFY
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";



const validateForm = (type, data) => {
  const clean = (val) => (val ? val.toString().trim() : "");

  // Regex rules
  const nameRegex = /^[A-Za-z]{2,20}$/; // 2-10 letters only, no numbers/spaces
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  const orgNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/; // Single middle space allowed
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (type === "user") {
    const fName = clean(data.first_name);
    const lName = clean(data.last_name);
    const email = clean(data.email);
    const phone = clean(data.phone_no);

    if (!nameRegex.test(fName)) return "First Name: 2-20 letters only (no numbers/spaces).";
    if (!nameRegex.test(lName)) return "Last Name: 2-20 letters only (no numbers/spaces).";
    if (!emailRegex.test(email) || email.length < 2 || email.length > 50) return "Email: Must be valid and 2-50 characters.";
    if (!/^\d{10,15}$/.test(phone)) return "Phone: Must be 10-15 digits.";
  }

  if (type === "org") {
    const orgName = clean(data.name);
    if (orgName.length < 2 || orgName.length > 50) return "Org Name: 2-50 characters required.";
    if (!orgNameRegex.test(orgName)) return "Org Name: No special chars, single middle spaces only.";
  }

  if (type === "password") {
    if (!passwordRegex.test(data.password)) return "Password: 8+ chars, Uppercase, Lowercase, Number, and Special Character.";
    if (data.password !== data.confirm_password) return "Passwords do not match.";
  }

  return null; // No errors
};


// ✅ Runtime single-field validation
const validateField = (type, data, field) => {
  const clean = (val) => (val ? val.toString().trim() : "");

  const nameRegex = /^[A-Za-z]{2,20}$/;
  const emailRegex = /^[a-zA-Z0-9]+(\.[a-zA-Z0-9]+)?@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  const orgNameRegex = /^[A-Za-z0-9]+( [A-Za-z0-9]+)*$/;
  const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;

  if (type === "user") {
    const fName = clean(data.first_name);
    const lName = clean(data.last_name);
    const email = clean(data.email);
    const phone = clean(data.phone_no);

    if (field === "first_name" && !nameRegex.test(fName))
      return "2-20 letters only (no numbers/spaces)";
    if (field === "last_name" && !nameRegex.test(lName))
      return "2-20 letters only (no numbers/spaces)";
    if (
      field === "email" &&
      (!emailRegex.test(email) || email.length < 2 || email.length > 50)
    )
      return "Email must be valid (2-50 chars)";
    if (field === "phone_no" && !/^\d{10}$/.test(phone))
      return "Phone must be 10 digits";
  }

  if (type === "org") {
    const orgName = clean(data.name);
    if (field === "org_name") {
      // 2-50 chars, alphanumeric, at least 1 letter, optional single space
      const orgRegex = /^(?=.*[a-zA-Z])[a-zA-Z0-9]+( [a-zA-Z0-9]+)*$/;
      if (!orgName || orgName.length < 2 || orgName.length > 50)
        return "Org name: 2-50 chars required";
      if (!orgRegex.test(orgName))
        return "Org name must be alphanumeric, at least 1 letter, optional single space";
    }
  }
  if (type === "password") {
    if (field === "password" && !passwordRegex.test(data.password))
      return "8+ chars, Uppercase, Lowercase, Number, Special char";
    if (field === "confirm_password" && data.password !== data.confirm_password)
      return "Passwords do not match";
  }

  return ""; // no error
};


// Remove leading/trailing spaces, multiple consecutive spaces
const sanitizeInput = (value, allowSingleSpace = false) => {
  let val = value.replace(/^\s+/g, ""); // remove leading spaces
  if (allowSingleSpace) {
    val = val.replace(/\s+/g, " "); // replace multiple spaces with single
  } else {
    val = val.replace(/\s+/g, ""); // remove all spaces
  }
  return val;
};
const Profile = () => {
  const [profile, setProfile] = useState(null);
  const [passwordData, setPasswordData] = useState({
    old_password: "",
    password: "",
    confirm_password: "",
  });

  const [showPassword, setShowPassword] = useState({
    old: false,
    new: false,
    confirm: false,
  });



  const nameRegex = /^[A-Za-z]{2,20}$/;
  const emailRegex = /^[a-zA-Z0-9._]+@[a-zA-Z0-9-]+\.[a-zA-Z]{2,}$/;
  const orgNameRegex = /^[A-Za-z]+( [A-Za-z]+)*$/;

  const [errors, setErrors] = useState({});

  const token = localStorage.getItem("accessToken");


  const API_URL = process.env.REACT_APP_API_DJANGO_URL;



  // ONLY showing changed parts clearly — rest remains SAME

  // ✅ UPDATED validateField (SAME AS CreateEngineer)
  const validateField = (name, value) => {
    let error = "";

    if (name === "first_name" || name === "last_name") {
      if (!value) {
        error = "Required";
      } else if (!nameRegex.test(value)) {
        error = "Min 2 and max 20 alphabets are allowed.";
      }
    }

    if (name === "org_name") {
      if (!value) {
        error = "Required";
      } else if (!orgNameRegex.test(value)) {
        error = "Only alphabets and single spaces allowed";
      }
    }
    if (name === "email" || name === "org_email") {
      if (!value) {
        error = "Email required";
      } else if (value.length < 2 || value.length > 50) {
        error = "Email must be 2-50 characters";
      } else if (!emailRegex.test(value)) {
        error = "Invalid email format";
      }
    }

    if (name === "phone_no" || name === "org_phone") {
      if (!value) {
        error = "Phone number required";
      } else if (!/^[6-9]\d{9}$/.test(value)) {
        error = "Must be exactly 10 digits";
      }
    }

    return error;
  };


  useEffect(() => {
    fetchProfile();
  }, []);

  // ✅ FETCH PROFILE
  const fetchProfile = async () => {
    try {
      const res = await axios({
        url: `${API_URL}/api/get_profile_info/`,
        method: "GET",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {},
      });

      setProfile(res.data);
    } catch (err) {
      console.error(err.response?.data || err.message);
    }
  };

  // ✅ UPDATE PROFILE
  const handleUpdateProfile = async () => {


    const fields = ["first_name", "last_name", "email", "phone_no"];
    let newErrors = {};

    fields.forEach((field) => {
      const value = profile.user_details[field];
      const error = validateField(field, value);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Fix errors first");
      return;
    }

    try {
      await axios({
        url: `${API_URL}/api/update_profile_info/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
  first_name: profile.user_details.first_name,
  last_name: profile.user_details.last_name,
  email: profile.user_details.email,
  phone_no: profile.user_details.phone_no,
},
      });

      toast.success("Profile updated successfully");
      await fetchProfile();

    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Update failed");
    }
  };

  // ✅ CHANGE PASSWORD
  const handleChangePassword = async () => {

    if (!passwordData.old_password || !passwordData.password) {
      toast.error("All password fields required");
      return;
    }

    if (passwordData.password !== passwordData.confirm_password) {
      toast.error("Passwords do not match");
      return;
    }
    try {
      await axios({
        url: `${API_URL}/api/change_user_password/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: passwordData,
      });

      toast.success("Password changed successfully");

      setPasswordData({
        old_password: "",
        password: "",
        confirm_password: "",
      });
    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Error changing password");
    }
  };



  const handleUpdateOrganization = async () => {

  //   if (!canUpdateOrganization) {
  //   toast.error("You don't have permission to update organization details.");
  //   return;
  // }
    const fields = ["org_name", "org_email", "org_phone"];
    let newErrors = {};

    fields.forEach((field) => {
      let value;

      if (field === "org_name") value = profile.organization_info.name;
      if (field === "org_email") value = profile.organization_info.email;
      if (field === "org_phone") value = profile.organization_info.phone_no;

      const error = validateField(field, value);
      if (error) newErrors[field] = error;
    });

    setErrors(newErrors);

    if (Object.keys(newErrors).length > 0) {
      toast.error("Fix errors first");
      return;
    }
    try {
      await axios({
        url: `${API_URL}/api/customer/update/${profile.organization_info.customer_id}/`,
        method: "POST",
        headers: {
          Authorization: `Bearer ${token}`,
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        data: {
          title: profile.organization_info.name,   // 🔥 IMPORTANT (3TP expects title)
          email: profile.organization_info.email,
          phone_no: profile.organization_info.phone_no,
        },
      });

      toast.success("Organization updated successfully");
    } catch (err) {
      console.error(err.response?.data || err.message);
      toast.error(err.response?.data?.error || "Update failed");
    }
  };


  const handleChange = (section, field, value) => {
    let updatedValue = value;

    // ✅ First & Last Name
    // ✅ First & Last Name (NO spaces)
    if (field === "first_name" || field === "last_name") {
      updatedValue = value
        .replace(/\s/g, "")
        .replace(/[^A-Za-z]/g, "");
    }

    // ✅ Organization Name (ALLOW spaces)
    if (field === "org_name") {
      updatedValue = value
        .replace(/[^A-Za-z ]/g, "")   // allow space
        .replace(/\s{2,}/g, " ");     // prevent multiple spaces
    }

    // ✅ Email
    // ✅ Email
if (field === "email" || field === "org_email") {
  updatedValue = value
    .replace(/\s/g, "") // remove spaces
    .replace(/\.{2,}/g, "."); // prevent multiple dots together

  // prevent more than ONE dot before @
  const parts = updatedValue.split("@");

  if (parts[0]) {
    parts[0] = parts[0].replace(/\.(?=.*\.)/g, "");
  }

  updatedValue = parts.join("@");
}

    // ✅ Phone
    if (field === "phone_no" || field === "org_phone") {
      updatedValue = value
        .replace(/\D/g, "")
        .slice(0, 10);

      if (updatedValue.length === 1 && !/[6-9]/.test(updatedValue)) {
        updatedValue = "";
      }
    }

    // ✅ STATE UPDATE (FIXED MAPPING)
    if (section === "user") {
      setProfile((prev) => ({
        ...prev,
        user_details: {
          ...prev.user_details,
          [field]: updatedValue,
        },
      }));
    } else {
      setProfile((prev) => ({
        ...prev,
        organization_info: {
          ...prev.organization_info,
          [field === "org_name"
            ? "name"
            : field === "org_email"
              ? "email"
              : "phone_no"]: updatedValue,
        },
      }));
    }

    // ✅ Runtime validation
    const error = validateField(field, updatedValue);

    setErrors((prev) => ({
      ...prev,
      [field]: error,
    }));
  };

if (!profile) return <div>Loading...</div>;

// const userRole = profile?.role_info?.role_name;

// const canUpdateOrganization =
//   ["superadmin", "ttadmin", "SA", "TTA"].includes(userRole);
const userRole = profile?.role_info?.role_name;

const canUpdateOrganization =
  ["SA", "TTA","superadmin", "ttadmin"].includes(userRole);
  
  

  return (
    <div className="profile-container">
      <ToastContainer position="top-right" autoClose={3000} />

      {/* 🔥 SIDE BY SIDE */}
      <div className="profile-row">

        {/* 🔥 ADMIN PROFILE (UNCHANGED) */}
        <div className="profile-card">
          <div className="card-header">
            <User />
            <h3>Admin Profile</h3>
          </div>

          <div className="profile-grid">
            <div className="form-group">
              <label>First Name</label>
              <input
                value={profile.user_details.first_name}
                onChange={(e) =>
                  handleChange("user", "first_name", e.target.value)
                }
              />
              <span className="error">{errors.first_name}</span>
            </div>

            <div className="form-group">
              <label>Last Name</label>
              <input
                value={profile.user_details.last_name}
                onChange={(e) =>
                  handleChange("user", "last_name", e.target.value)
                }
              />
              <span className="error">{errors.last_name}</span>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                value={profile.user_details.email}
                onChange={(e) =>
                  handleChange("user", "email", e.target.value)
                }
                onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }}
              />
              <span className="error">{errors.email}</span>
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                value={profile.user_details.phone_no}
                onChange={(e) =>
                  handleChange("user", "phone_no", e.target.value)
                }
              />
              <span className="error">{errors.phone_no}</span>
            </div>
          </div>

          <button className="update-btn" onClick={handleUpdateProfile}>
            Update Profile
          </button>

          <hr className="divider" />

          {/* 🔐 PASSWORD (UNCHANGED) */}
          <div className="card-header">
            <Lock />
            <h3>Change Password</h3>
          </div>

          <div className="password-form">
            {/* OLD PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword.old ? "text" : "password"}
                placeholder="Old Password"
                value={passwordData.old_password}
                onChange={(e) =>
                  setPasswordData({
                    ...passwordData,
                    old_password: e.target.value,
                  })
                }
              />
              <span
                onClick={() =>
                  setShowPassword({ ...showPassword, old: !showPassword.old })
                }
              >
                {showPassword.old ? <Eye size={18} /> : <EyeOff size={18} />}
              </span>
            </div>

            {/* NEW PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword.new ? "text" : "password"}
                placeholder="New Password"
                value={passwordData.password}
                onChange={(e) => {
                  const val = sanitizeInput(e.target.value, false);
                  setPasswordData({ ...passwordData, password: val });
                  setErrors({
                    ...errors,
                    password: validateField("password", { ...passwordData, password: val }, "password"),
                  });
                }}
              />
              <span
                onClick={() =>
                  setShowPassword({ ...showPassword, new: !showPassword.new })
                }
              >
                {showPassword.new ? <Eye size={18} /> : <EyeOff size={18} />}
              </span>
              {errors.password && <span className="error-msg">{errors.password}</span>}
            </div>

            {/* CONFIRM PASSWORD */}
            <div className="password-field">
              <input
                type={showPassword.confirm ? "text" : "password"}
                placeholder="Confirm Password"
                value={passwordData.confirm_password}
                onChange={(e) => {
                  const val = sanitizeInput(e.target.value, false);
                  setPasswordData({ ...passwordData, confirm_password: val });
                  setErrors({
                    ...errors,
                    confirm_password: validateField("password", { ...passwordData, confirm_password: val }, "confirm_password"),
                  });
                }}
              />
              <span
                onClick={() =>
                  setShowPassword({
                    ...showPassword,
                    confirm: !showPassword.confirm,
                  })
                }
              >
                {showPassword.confirm ? <Eye size={18} /> : <EyeOff size={18} />}
              </span>
              {errors.confirm_password && <span className="error-msg">{errors.confirm_password}</span>}
            </div>

            <button onClick={handleChangePassword}>Change Password</button>
          </div>
        </div>

        {/* 🔥 ORGANIZATION PROFILE (RIGHT SIDE) */}
        {/* <div className="profile-card">
          <div className="card-header">
            <Building2 />
            <h3>Organization Info</h3>
          </div>

          <div className="profile-grid">

            
            <div className="form-group">
              <label>Organization Name</label>
              <input
                value={profile.organization_info.name}
                onChange={(e) =>
                  handleChange("org", "org_name", e.target.value)
                }
              />
              <span className="error">{errors.org_name}</span>
            </div>

            <div className="form-group">
              <label>Email</label>
              <input
                value={profile.organization_info.email}
                onChange={(e) =>
                  handleChange("org", "org_email", e.target.value)
                }
                onKeyDown={(e) => {
                  if (e.key === " ") e.preventDefault();
                }}
              />
              <span className="error">{errors.org_email}</span>
            </div>

            <div className="form-group">
              <label>Phone</label>
              <input
                value={profile.organization_info.phone_no}
                onChange={(e) =>
                  handleChange("org", "org_phone", e.target.value)
                }
              />
              <span className="error">{errors.org_phone}</span>
            </div>

          </div>

          
        <button
  className="update-btn"
  onClick={handleUpdateOrganization}
  disabled={!canUpdateOrganization}
  title={
    !canUpdateOrganization
      ? "You don't have permission to update organization details"
      : ""
  }
>
  Update Organization
</button>

        </div> */}

      </div>
    </div>
  );
};

export default Profile;